import React, { useEffect } from "react";
import { hot } from "react-hot-loader";
import { AppContext } from "../../AppContext";
import ReusableStepPromo from "../common/promo/ReusableStepPromo";
import { actAsPremium } from "../common/promo/hooks";
import { Button, Form, Input, notification, Row, Col } from "antd";
import { TestCaseStepInputCollection } from "../TestCaseAdd/TestCaseStepInputCollection";
import * as common from "../../utils/common";
import { ReusableStepsApi } from "../../services/generated-sdk";
import { FormCreateOption } from "antd/lib/form";
//const changeUrlLocation = common.changeUrlLocation;
const FormItem = Form.Item;

interface Props {
  history?: any;
  form: any;
  onSubmit: () => void;
  steps?: any[];
  isModal?: boolean;
}
function InsertReusableStepStatic({
  history,
  form,
  isModal = false,
  ...props
}: Props) {
  const { projectId, setPageTitle } = React.useContext(AppContext);
  const [saving, setSaving] = React.useState(false);
  const [isAccessAllowed] = actAsPremium();
  if (!isAccessAllowed) {
    return <ReusableStepPromo />;
  }
  useEffect(
    () => {
      if (props.steps && Array.isArray(props.steps))
        form.setFieldsValue({ steps: props.steps });
    },
    [props.steps]
  );

  const { getFieldDecorator } = form;
  const api = new ReusableStepsApi();

  const handleSubmit = e => {
    e.preventDefault(e);
    form.validateFields(async (err, values) => {
      if (!err) {
        //console.log("Received values of form: ", values);
        if (
          values &&
          values["steps"] &&
          values["steps"][0] &&
          values["steps"][0]["step"]
        ) {
          let hasError = false;
          values["steps"].map(({ step, expectedResult }) => {
            if (!step) {
              hasError = true;
            }
          });
          if (hasError) {
            setSaving(false);
            notification.error({ message: "Steps cannot be empty" });
            return;
          }

          delete values.add_new_case;
          setSaving(true);
          try {
            await api.saveReusableStep({
              project: projectId,
              reusableStepPayload: { ...values, project: projectId }
            });
            setSaving(false);
            notification["success"]({
              message: "Reusable step added",
              description: ""
            });
            form.resetFields();
            props.onSubmit();
            //history.push(`/project/${projectId}/reusable_steps`);
          } catch (e) {
            console.log({ rsAdd_error: e });
            setSaving(false);
            if (e.json) {
              e.json().then(data => {
                console.log({ rsAdd_error2: data });
                common.handleError(data.statusCode, {}, data.message || "");
              });
            }
          }
        } else {
          notification.error({ message: "Please add steps" });
        }
      } else {
        console.log("error in form ", err);
      }
    });
  };

  const onCancel = () => {
    form.resetFields();
    props.onSubmit();
    //history.push(`/project/${projectId}/reusable_steps`);
    return false;
  };

  const setFocusOn = btnId => {
    try {
      let titleElement = document.getElementById("add_new_case");
      if (titleElement) {
        titleElement.focus();
        form.setFieldsValue({ add_new_case: "" });
      }

      let btnElement = document.getElementById(btnId);
      if (btnElement) {
        btnElement.focus();
      }
    } catch (e) {}
  };

  return (
    <div>
      <Form onSubmit={isModal ? () => {} : handleSubmit}>
        <FormItem label="Name" key="name">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: "This field is required"
              },
              {
                message: "Invalid Name.",
                whitespace: true
              }
            ],
            initialValue: ""
          })(<Input placeholder="Name" />)}
        </FormItem>
        <FormItem label="" key="steps">
          {getFieldDecorator(`steps`, {
            initialValue: [{ step: "", expected_result: "" }]
          })(
            <TestCaseStepInputCollection
              showReusableStepLink={false}
              showLabel={true}
              steps={props.steps ? props.steps : []}
              projectId={projectId}
            />
          )}
        </FormItem>
        <br />
        <div style={{ height: "1px", width: "1px", overflow: "hidden" }}>
          <FormItem key="add_new_case">
            {getFieldDecorator("add_new_case", { initialValue: "" })(
              <Input id="add_new_case" />
            )}
          </FormItem>
        </div>
        <div style={{ float: "right" }}>
          <Button
            type="primary"
            htmlType={isModal ? "button" : "submit"}
            onClick={handleSubmit}
            loading={saving}
            className="btn-success"
            size="large"
            id="rs-save-btn"
            onMouseOver={e => setFocusOn("rs-save-btn")}
          >
            Save
          </Button>{" "}
          {/*} <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>*/}
        </div>
        <br />
        <br />
      </Form>
    </div>
  );
}

const mapPropsToFields = { mapPropsToFields(props: Props) {} };
const FormOptions: FormCreateOption<Props> = mapPropsToFields;
const InsertReusableStep = hot(module)(
  Form.create(FormOptions)(InsertReusableStepStatic)
);
export default InsertReusableStep;
